(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('story-rotator')) {
    customElements.define(
      'story-rotator',
      class extends HTMLElement {
        connectedCallback() {
          const slidesNode = this.querySelector('script[data-story-slides]');
          if (!slidesNode) return;
          try {
            this.slides = JSON.parse(slidesNode.textContent);
          } catch (error) {
            this.slides = [];
          }
          if (!Array.isArray(this.slides) || this.slides.length < 2) return;

          const layerImgs = this.querySelectorAll('.story__image');
          this.imgA = layerImgs[0];
          this.imgB = layerImgs[1];
          if (!this.imgA || !this.imgB) return;

          this.interval = parseInt(this.dataset.interval, 10) || 4000;
          this.duration = parseInt(this.dataset.duration, 10) || 800;
          this.autoplay = this.dataset.autoplay !== 'false';
          this.currentIndex = 0;
          this.activeLayer = 'a';

          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.autoplay || reduceMotion) return;

          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.start();
              else this.stop();
            });
          });
          this.observer.observe(this);
        }

        disconnectedCallback() {
          this.stop();
          if (this.observer) this.observer.disconnect();
        }

        start() {
          if (this.timer) return;
          this.timer = window.setInterval(() => this.advance(), this.interval);
        }

        stop() {
          if (!this.timer) return;
          window.clearInterval(this.timer);
          this.timer = null;
        }

        setImageSrc(img, url) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = url;
        }

        advance() {
          const total = this.slides.length;
          const activeImg = this.activeLayer === 'a' ? this.imgA : this.imgB;
          const inactiveImg = this.activeLayer === 'a' ? this.imgB : this.imgA;

          activeImg.classList.remove('is-active');
          inactiveImg.classList.add('is-active');

          const newIndex = (this.currentIndex + 1) % total;
          const afterIndex = (newIndex + 1) % total;
          const afterUrl = this.slides[afterIndex];

          window.setTimeout(() => {
            this.setImageSrc(activeImg, afterUrl);
          }, this.duration);

          this.currentIndex = newIndex;
          this.activeLayer = this.activeLayer === 'a' ? 'b' : 'a';
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-collections-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(wrapper) {
      var track = wrapper.querySelector('.sub-collections-slider__track');
      var prevBtn = wrapper.querySelector('.sub-collections-slider-btn--prev');
      var nextBtn = wrapper.querySelector('.sub-collections-slider-btn--next');
      if (!track || !prevBtn || !nextBtn) return;

      function updateState() {
        var overflowing = track.scrollWidth > track.clientWidth + 1;
        wrapper.classList.toggle('is-overflowing', overflowing);
        var atStart = track.scrollLeft <= 0;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        prevBtn.classList.toggle('is-hidden', atStart);
        nextBtn.classList.toggle('is-hidden', atEnd);
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateState);
      }, { passive: true });

      var resizeFrame = null;
      window.addEventListener('resize', function () {
        if (resizeFrame) return;
        resizeFrame = window.requestAnimationFrame(function () {
          resizeFrame = null;
          updateState();
        });
      });

      updateState();
    }

    document.querySelectorAll('.sub-collections-slider__wrapper').forEach(initSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
